import { useState } from "react";
import Hostname from "../hooks/Hostname";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MobileMenu from "../components/mobile/MobileMenu";

const MobileLayout = ({ children }) => {
  const host = Hostname();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="mobile-shell">
      <div className="mobile-topbar">
        <button
          className="mobile-menu-button"
          onClick={() => setMenuOpen(true)}
        >
          <MenuOutlinedIcon />
        </button>

        <div className="mobile-brand">
          <img src={host?.Logo} alt="Logo" />
        </div>

        <div />
      </div>

      <div className="mobile-content">{children}</div>

      {menuOpen && (
        <MobileMenu onClose={() => setMenuOpen(false)} />
      )}
    </div>
  );
};

export default MobileLayout;

